import { css } from '@emotion/react';

const globalStyles = css`
  @font-face {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 400;
    src: url('/fonts/roboto-400.woff2') format('woff2'),
      url('/fonts/roboto-400.woff') format('woff');
    text-rendering: optimizeLegibility;
    font-display: fallback;
  }

  @font-face {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 500;
    src: url('/fonts/roboto-500.woff2') format('woff2'),
      url('/fonts/roboto-500.woff') format('woff');
    text-rendering: optimizeLegibility;
    font-display: fallback;
  }

  @font-face {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 700;
    src: url('/fonts/roboto-700.woff2') format('woff2'),
      url('/fonts/roboto-700.woff') format('woff');
    text-rendering: optimizeLegibility;
    font-display: fallback;
  }

  @font-face {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 900;
    src: url('/fonts/roboto-900.woff2') format('woff2'),
      url('/fonts/roboto-900.woff') format('woff');
    text-rendering: optimizeLegibility;
    font-display: fallback;
  }

  html {
    font-size: 62.5%; /* 62.5% of 16px = 10px */
  }

  body {
    background-color: white;
    color: rgba(0, 0, 0, 0.8);
    font-size: 1.5rem; /* 1.5 * 10px = 15px */
  }
`;

export default globalStyles;
